export default __webpack_public_path__ + "487bb048ecd34632d946da8b0b395848.svg";